import { InfoField } from '~/shared/InfoField';
import { formatAddress } from '~/util/functions';
import { getPatientAddressesOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Button } from '~/shared/components/buttons/Button';
import { Pencil } from 'lucide-react';
import { PatientAddressesFormModal } from './forms/PatientAddressesFormModal';

export function PatientAddresses({ stayId }: { stayId: string }) {
	const { data: addresses } = useSuspenseQuery(getPatientAddressesOptions(stayId));

	return (
		<>
			<div className="flex justify-end gap-2">
				<Button
					Icon={Pencil}
					aria-label="Edit Demographics"
					intent="neutral"
					renderModal={closeModal => <PatientAddressesFormModal stayId={stayId} closeModal={closeModal} />}
				/>
			</div>
			<div className="mb-6 grid grid-cols-1 gap-4">
				<InfoField label="Visit Address" value={formatAddress(addresses.visitAddress)} />
				<InfoField
					label="Primary Address"
					value={!addresses.primaryAddressSameAsVisitAddress ? formatAddress(addresses.primaryAddress) : 'Same as Visit Address'}
				/>
				<InfoField
					label="Mailing Address"
					value={!addresses.mailingAddressSameAsVisitAddress ? formatAddress(addresses.mailingAddress) : 'Same as Visit Address'}
				/>
				<div className="grid grid-cols-2 gap-4">
					<InfoField label="Location of Care" value={addresses.locationOfCareLabel} />
				</div>
			</div>
		</>
	);
}
